export default __webpack_public_path__ + "static/media/shared-cell.22db8920.svg";